<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <form
    [formGroup]="institutionForm"
    (ngSubmit)="isCreating ? createInstitution() : updateInstitution()"
    *ngIf="institution"
  >
    <page-header
      [icon]="'fa-money-bill'"
      [title]="isCreating ? 'institution.new' : 'institution'"
      [appendNoTranslationTitlePart]="institution ? institution.name : ''"
    >
      <ng-container class="header-button">
        <btn
          [label]="'save'"
          [title]="'save' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-check'"
          [btnType]="'submit'"
          [isLoading]="loading"
          [spinnerClassesString]="'spinner-white'"
          [btnDisabled]="loading"
          data-cy="create-instituton"
        ></btn>
        <btn
          *ngIf="!isCreating"
          [icon]="'far-trash-alt'"
          (onEvent)="deleteInstitution()"
          [label]="'delete'"
          [title]="'delete' | translate"
          [classes]="['btn-first-red', 'float-right', 'mr-2']"
          data-cy="delete-instituton"
        ></btn>
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'mr-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="triggerBackBtn()"
        ></btn>
      </ng-container>
    </page-header>

    <section class="content">
      <div class="card">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-12">
                <form-row-input
                  [label]="'institution.name'"
                  [formGroup]="institutionForm"
                  formControlName="name"
                  [required]="
                    institutionForm.get('name').errors !== null && institutionForm.get('name').errors.required
                  "
                  [requiredCssClass]="submitted && formControls.name.errors"
                  [noMarginBottom]="true"
                  data-cy="name"
                ></form-row-input>
              </div>
            </div>
          </div>
          <div *ngIf="!loading" class="col-sm-6">
            <div class="d-flex row">
              <div class="col-6">
                <div class="form-group">
                  <label>{{ 'checkouts' | translate }}:</label>
                  <ng-container *ngIf="checkouts.length > 0">
                    <div class="mb-2" *ngFor="let checkout of checkouts">
                      <form-row-checkbox
                        [label]="checkout.name"
                        [cursorPointer]="true"
                        (change)="toggleCheckout(checkout, $event)"
                        [model]="isChosenCheckout(checkout)"
                      >
                      </form-row-checkbox>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="checkouts.length < 1">
                    {{ 'institution.no-ordination' | translate }}
                  </ng-container>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group">
                  <label>{{ 'depots' | translate }}:</label>
                  <div class="mb-2" *ngFor="let depot of depots">
                    <form-row-checkbox
                      [label]="depot.name"
                      [cursorPointer]="true"
                      (change)="toggleDepot(depot, $event)"
                      [model]="isChosenDepot(depot)"
                    >
                    </form-row-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</div>
